import { gql } from '@apollo/client';
const REMOVE_PROJECTION_POINT = gql `
  mutation removeProjectionPoint($projectionPointId: ID!) {
    removeProjectionPoint(projectionPointId: $projectionPointId) {
      removed
    }
  }
`;
export default REMOVE_PROJECTION_POINT;
